// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16zWl","colBig":"styles_colBig__1qQXY","colSmall":"styles_colSmall__dwX87"};